var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import FullCalendar from '@fullcalendar/react';
import BootstrapTheme from '@fullcalendar/bootstrap';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getLocaleFullcalendar } from '../../helpers/Format';
import { T } from '../../helpers/i18n';
import theme from '../../Theme';
import './CalendarAvailable.css';
import cloneDeep from 'lodash/cloneDeep';
import { ModalDisableHours } from './ModalDisableHours';
import { isInRange } from './Utils';
var CalendarAvailable = /** @class */ (function (_super) {
    __extends(CalendarAvailable, _super);
    function CalendarAvailable(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.calendarRef = React.createRef();
        _this.handleHourClick = function (day, horaIda) {
            // const {daySelected} = this.state
            var daySelected = cloneDeep(_this.state.daySelected);
            var position = daySelected.hours.findIndex(function (value) { return value.hours === horaIda.hours && value.minutes === horaIda.minutes; });
            if (position !== -1) { // está
                // elimino la hora
                daySelected.hours.splice(position, 1);
            }
            else { // no está
                // añado la hora
                daySelected.hours.push(horaIda);
            }
            _this.setState({ daySelected: daySelected });
        };
        _this.handleCancelClick = function () {
            _this.setState({ daySelected: null });
        };
        _this.handleOKClick = function () {
            var disabledDays = applyDaySelected(_this.state.daySelected, _this.state.disabledDays, _this.props.stretch.tramoHora);
            _this.setState({ disabledDays: disabledDays, daySelected: null }, function () {
                _this.props.onDateClick(disabledDays);
            });
        };
        _this.handleRangeOKClick = function () {
            if (!(_this.state.rangeFrom && _this.state.rangeTo && _this.state.daySelected)) {
                return;
            }
            var _a = _this.state, rangeFrom = _a.rangeFrom, rangeTo = _a.rangeTo, daySelected = _a.daySelected, disabledDays = _a.disabledDays;
            var resultDisabledDays = disabledDays;
            var dateFrom = new Date(rangeFrom.year, rangeFrom.month, rangeFrom.day);
            dateFrom.setHours(0, 0, 0, 0);
            var dateTo = new Date(rangeTo.year, rangeTo.month, rangeTo.day);
            dateTo.setHours(0, 0, 0, 0);
            var date = dateFrom;
            while (date <= dateTo) {
                var tempDaySelected = {
                    year: date.getFullYear(),
                    month: date.getMonth(),
                    day: date.getDate(),
                    hours: daySelected.hours
                };
                resultDisabledDays = applyDaySelected(tempDaySelected, resultDisabledDays, _this.props.stretch.tramoHora);
                date.setDate(date.getDate() + 1); // incremento el día
            }
            _this.setState({
                disabledDays: resultDisabledDays,
                daySelected: null,
                rangeFrom: null,
                rangeTo: null
            }, function () {
                _this.props.onDateClick(resultDisabledDays);
            });
        };
        _this.handleDateClick = function (info) {
            // if (info.dayEl.className.includes('fc-disabled-day') || info.dayEl.className.includes('fc-other-month')) return
            if (!_this.props.onDateClick)
                return;
            var now = new Date();
            info.date.setHours(23, 59, 59, 999);
            var day = new Date(info.date);
            if (day < now)
                return;
            var stretch = _this.props.stretch;
            var othermonth = false;
            if (info.dayEl.className.includes('fc-disabled-day') || info.dayEl.className.includes('fc-other-month')) {
                othermonth = true;
            }
            if (othermonth) {
                return;
            }
            var opacity = othermonth ? 0.4 : 1;
            var disabledDays = cloneDeep(_this.state.disabledDays);
            var position = _this.state.disabledDays.findIndex(function (value) {
                return value.day === info.date.getDate() && value.month === info.date.getMonth() && value.year === info.date.getFullYear();
            });
            var daySelected;
            if (stretch.tramoHora) {
                if (stretch.horasIda && stretch.horasIda.length > 0) {
                    if (position !== -1) { // está con horas anuladas
                        daySelected = disabledDays[position];
                        if (!daySelected.hours) { // asigno a array vacío si no tiene hours
                            daySelected.hours = [];
                        }
                    }
                    else { // no tiene horas anuladas
                        daySelected = {
                            year: info.date.getFullYear(),
                            month: info.date.getMonth(),
                            day: info.date.getDate(),
                            hours: []
                        };
                    }
                    _this.setState({
                        daySelected: daySelected
                    }, function () {
                    });
                }
            }
            else {
                daySelected = {
                    year: info.date.getFullYear(),
                    month: info.date.getMonth(),
                    day: info.date.getDate(),
                    hours: position !== -1 ? [] : null
                };
                _this.setState({ daySelected: daySelected });
                /*if (position !== -1) { // está deshabilitado
                  disabledDays.splice(position, 1)
                } else {
                  disabledDays.push({
                    year: info.date.getFullYear(),
                    month: info.date.getMonth(),
                    day: info.date.getDate(),
                    hours: []
                  })
                }
                return this.setState({disabledDays})*/
            }
            renderContent(info, _this.state.disabledDays, opacity);
        };
        _this.handleDayRender = function (info) {
            if (!_this.props.stretch)
                return;
            var now = new Date();
            info.date.setHours(23, 59, 59, 999);
            var day = new Date(info.date);
            if (day < now)
                return;
            var othermonth = false;
            if (info.el.className.includes('fc-disabled-day') || info.el.className.includes('fc-other-month'))
                othermonth = true;
            var disabledDay = _this.state.disabledDays.find(function (value) { return value.day === info.date.getDate() && value.month === info.date.getMonth() && value.year === info.date.getFullYear(); });
            var backColor = theme.color.backgreen, color = 'green', content = T('available');
            if (isInRange(_this.state.rangeFrom, _this.state.rangeTo, info.date)) {
                backColor = theme.color.backblue;
                // color = theme.color.backblue
            }
            else {
                if (disabledDay) {
                    color = 'red';
                    if (_this.props.stretch.tramoHora) {
                        var horasIda = _this.props.stretch.horasIda;
                        var hoursFiltered_1 = filterHours(horasIda, disabledDay.hours); // miro si hay horas que estuvieron en configuración pero posteriormente se eliminaron 
                        if (disabledDay.hours && (disabledDay.hours.length === 0 || !disabledDay.hours)) {
                            // todas las horas están deshabilitadas, disabledDay.hours = [] o disabledDay.hours es undefined o null
                            // ocurre cuando el servicio no es tramoHora, se deshabilita algún día y después se pasa a tramoHora
                            hoursFiltered_1 = horasIda;
                        }
                        backColor = hoursFiltered_1.length === _this.props.stretch.horasIda.length ? theme.color.backred : theme.color.backgreen;
                        content = "<div style=\"width: 100%; margin: 7px; display: flex; flex-wrap: wrap; align-items: flex-start; align-content: flex-start; gap: 2px;\">";
                        horasIda.forEach(function (horaIda) {
                            var colorText = 'green';
                            if (hoursFiltered_1.find(function (hourFiltered) { return hourFiltered.hours === horaIda.hours && hourFiltered.minutes === horaIda.minutes; })) {
                                colorText = 'red';
                            }
                            content += "<Text style=\"font-size: clamp(8px, 1vw, 14px); width: 45%; color: ".concat(colorText, ";\">").concat(horaIda.hours > 9 ? horaIda.hours : '0' + horaIda.hours, " : ").concat(horaIda.minutes > 9 ? horaIda.minutes : '0' + horaIda.minutes, "</Text>");
                        });
                        content += '</div>';
                    }
                    else {
                        backColor = theme.color.backred;
                        content = T('notAvailable');
                    }
                }
                else {
                    if (_this.props.stretch.tramoHora) {
                        content = "<div style=\"width: 100%; margin: 7px; display: flex; flex-wrap: wrap; align-items: flex-start; align-content: flex-start; gap: 2px;\">";
                        _this.props.stretch.horasIda.forEach(function (horaIda) {
                            content += "<Text style=\"font-size: clamp(8px, 1vw, 14px); width: 45%; color: green;\">".concat(horaIda.hours > 9 ? horaIda.hours : '0' + horaIda.hours, " : ").concat(horaIda.minutes > 9 ? horaIda.minutes : '0' + horaIda.minutes, "</Text>");
                        });
                        content += '</div>';
                    }
                }
            }
            var opacity = othermonth ? 0.3 : 1;
            info.el.innerHTML = renderDay(backColor, color, content, opacity);
        };
        _this.onToggle = function () {
            _this.setState({ daySelected: null });
        };
        _this.handleClickBar = function () {
            if (!_this.props.stretch.tramoHora) {
                if (_this.state.daySelected.hours) {
                    _this.handleEnableAll();
                }
                else {
                    _this.handleDisableAll();
                }
            }
        };
        _this.handleDisableAll = function () {
            var daySelected = _this.state.daySelected;
            daySelected.hours = [];
            if (_this.props.stretch.tramoHora) {
                _this.props.stretch.horasIda.forEach(function (horaIda) {
                    daySelected.hours.push(horaIda);
                });
            }
            _this.setState({ daySelected: daySelected });
        };
        _this.handleEnableAll = function () {
            var daySelected = _this.state.daySelected;
            if (!_this.props.stretch.tramoHora) {
                daySelected.hours = null;
            }
            else {
                daySelected.hours = [];
            }
            _this.setState({ daySelected: daySelected });
        };
        _this.externalCloseBtn = React.createElement("button", { className: "close", style: { color: theme.color.primary, position: 'absolute', top: '50px', right: '15px', fontSize: 60, opacity: 1 }, onClick: _this.onToggle }, "\u00D7");
        _this.state = {
            daySelected: null,
            disabledDays: ((_a = _this.props.disabledDays) === null || _a === void 0 ? void 0 : _a.map(function (disabledDay) {
                var _a, _b;
                if (((_a = disabledDay.hours) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    // por convección si el array es length 0 es que tiene todas las horas deshabilitadas, se las agrego para que el modal las muestre en rojo
                    disabledDay.hours = (_b = _this.props.stretch) === null || _b === void 0 ? void 0 : _b.horasIda;
                }
                return disabledDay;
            })) || [],
            rangeFrom: null,
            rangeTo: null
        };
        return _this;
    }
    CalendarAvailable.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var daySelected = cloneDeep(this.state.daySelected);
        var locale = getLocaleFullcalendar();
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalDisableHours, { rangeFrom: this.state.rangeFrom, rangeTo: this.state.rangeTo, title: (_a = this.props.stretch) === null || _a === void 0 ? void 0 : _a.name, onRangeFrom: function (day) {
                    _this.setState({ rangeFrom: day, daySelected: null });
                }, onRangeTo: function (day) {
                    _this.setState({ rangeTo: day, daySelected: null });
                }, onClearRange: function () {
                    _this.setState({
                        rangeFrom: null,
                        rangeTo: null,
                        daySelected: null
                    });
                }, onClickBar: this.handleClickBar, onOKRangeClick: this.handleRangeOKClick, showModal: !!daySelected, daySelected: daySelected, horasIda: (_b = this.props.stretch) === null || _b === void 0 ? void 0 : _b.horasIda, tramoHora: (_c = this.props.stretch) === null || _c === void 0 ? void 0 : _c.tramoHora, externalCloseBtn: this.externalCloseBtn, onToggle: this.onToggle, onHourClick: this.handleHourClick, onOKClick: this.handleOKClick, handleCancelClick: this.handleCancelClick, enableAll: this.handleEnableAll, disableAll: this.handleDisableAll }),
            React.createElement(Container, { style: { paddingBottom: '80px' } },
                React.createElement(Row, { className: "justify-content-center" },
                    React.createElement(Col, { className: "" },
                        React.createElement(FullCalendar
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            ref: this.calendarRef, resourceRender: function (arg) {
                                // @ts-ignore
                                // console.log('resourceRender: ', this.calendarRef.current.getApi().getDate())
                            }, header: {}, locale: locale, firstDay: 1, defaultView: "dayGridMonth" // "dayGridMonth" "listWeek" "listMonth"
                            , plugins: [BootstrapTheme, dayGridPlugin, interactionPlugin], 
                            // showNonCurrentDates={false}
                            dateClick: this.handleDateClick, dayRender: this.handleDayRender }))))));
    };
    return CalendarAvailable;
}(React.Component));
export default CalendarAvailable;
var renderDay = function (backgroundColor, color, content, opacity) {
    return "<div \n    style=\"\n      display: flex; \n      flex-direction: row; \n      justify-content: flex-start; \n      align-items: flex-start; \n      background-color: ".concat(backgroundColor, "; \n      opacity: ").concat(opacity, "; \n      height: 100%;\n      \" >\n        <p \n          class=\"fc-content-day\"\n          style=\"\n            color: ").concat(color, ";\n        \">\n          ").concat(content, "\n        </p>\n  </div>");
};
var renderContent = function (info, disabledDays, opacity) {
    var now = new Date();
    info.date.setHours(23, 59, 59, 999);
    var day = new Date(info.date);
    if (day < now)
        return;
    var dayDate = getDayDate(info);
    var position = disabledDays.findIndex(function (value) {
        return value.day === info.date.getDate() && value.month === info.date.getMonth() && value.year === info.date.getFullYear();
    });
    var backColor, content, color;
    if (position < 0) {
        backColor = theme.color.backgreen;
        color = 'green';
        content = T('available');
    }
    else {
        backColor = theme.color.backred;
        color = 'red';
        content = T('notAvailable');
    }
    /*if (onDateClick) {
      onDateClick(disabledDays)
    }*/
    info.dayEl.innerHTML = renderDay(backColor, color, content, opacity);
};
var getDayDate = function (info) { return ({
    day: info.date.getDate(),
    month: info.date.getMonth(),
    year: info.date.getFullYear(),
}); };
/*
  método para filtar las horas deshabilitadas en un IDay.hours ya que se puede dar el caso que alguna se haya eliminado
  en el servicio. Las que no estén en horasIda se eliminan
   */
var filterHours = function (horasIda, hoursSelected) {
    var result = hoursSelected.reduce(function (previous, hora) {
        if (horasIda.find(function (horaIda) { return horaIda.hours === hora.hours && horaIda.minutes === hora.minutes; })) {
            previous.push(hora);
        }
        return previous;
    }, []);
    /*console.log('filterHours - horasIda: ', horasIda)
    console.log('filterHours - hoursSelected: ', hoursSelected)
    console.log('filterHours - result: ', result)*/
    return result;
};
var applyDaySelected = function (daySelected, disabledDays, tramoHora) {
    // busco si el día está en la lista de días deshabilitados
    var position = disabledDays.findIndex(function (value) { return value.year === daySelected.year &&
        value.month === daySelected.month && value.day === daySelected.day; });
    // en tramoHora si daySelected.hours = [] quiere decir que se quiere habilitar el día
    if (tramoHora) {
        if (daySelected.hours.length === 0) { // habilitar
            if (position !== -1) { // está, lo elimino
                disabledDays.splice(position, 1);
            }
            // si no está no hacemos nada, puede que se esté en un rango y este día sea con valor contrario a lo que se desea hacer
        }
        else { // queremos deshabilitar
            if (position === -1) { // no está en la lista de días deshabilitados
                disabledDays.push(daySelected);
            }
            else { // está, le asigno dayselected
                disabledDays[position] = daySelected;
            }
        }
    }
    else {
        // en !tramoHora si no tiene hours quiere decir que se quiere habilitar el día
        if (!daySelected.hours) { // habilitar
            if (position !== -1) { // está, lo elimino
                disabledDays.splice(position, 1);
            }
            // si no está no hacemos nada, puede que se esté en un rango y este día sea con valor contrario a lo que se desea hacer
        }
        else { // queremos deshabilitar
            if (position === -1) { // no está en la lista de días deshabilitados
                // pongo hours a [] ya que el critero es que si tiene hours aunque sea vacío el día está deshabilitado
                daySelected.hours = [];
                disabledDays.push(daySelected);
            }
            else { // está, le asigno dayselected
                disabledDays[position] = daySelected;
            }
        }
    }
    return disabledDays;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarAvailable/CalendarAvailable.tsx
// module id = 513
// module chunks = 0